import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import ArticleList from '../components/article-list';

export default ({ data: { allPrismicArticle: { edges } }, location: { pathname }, pageContext: { category } }) => {
    if (!edges) return null;
    const articleList = edges.map(({ node }) => ({
        uid: node.uid,
        image: node.data.image,
        title: node.data.title.text,
        body: node.data.body.text,
        tags: node.tags,
        author: node.data.author,
        date: (new Date(node.last_publication_date)).toLocaleDateString('en-US', {
            day: 'numeric',
            year: 'numeric',
            month: 'short'
        })
    }));

    return <Layout pathname={pathname}><ArticleList pathname={pathname} articleList={articleList} category={category} /></Layout>;
};

export const query = graphql`
    query CarArticlesQuery {
        allPrismicArticle(sort: {fields: [last_publication_date], order: DESC}) {
            edges {
                node {
                    last_publication_date
                    tags
                    uid
                    data {
                        title {
                            text
                        }
                        body {
                            text
                        }
                        image {
                            url
                            dimensions {
                                width
                                height
                            }
                            localFile {
                                childImageSharp {
                                    fluid(maxWidth: 663, maxHeight: 200, quality: 100, cropFocus: CENTER) {
                                        ...GatsbyImageSharpFluid_withWebp
                                    }
                                }
                            }
                        }
                        author
                    }
                }
            }
        }
    }
`;
